import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../services/account/account.service';
import { InboxService } from '../../../../services/inbox/inbox.service';
import { OrganizationConfigService } from '../../../../services/organization-config/organization-config.service';
import { ClockInOutModalComponent } from '../modals/clock-in-out-modal/clock-in-out-modal.component';
import { ApiService } from '../../../../services/api/api.service';
import { SimpleMessageModalComponent } from '../../../../components/modals/simple-message-modal/simple-message-modal.component';

@Component({
  selector: 'app-navigation-top',
  templateUrl: './navigation-top.component.html',
  styleUrls: ['./navigation-top.component.css']
})
export class NavigationTopComponent {

  constructor(
    public apiService: ApiService,
    public accountService: AccountService,
    public inboxService: InboxService,
    public orgConfig: OrganizationConfigService,
    private modalService: NgbModal
  ) {}

  /**
   * Handle a request to log out.
   */
  handleLogoutClick($event) {
    $event.preventDefault();

    const modalRef = this.modalService.open(SimpleMessageModalComponent);
    modalRef.componentInstance.messageText = 'Are you sure you want to log out?';
    modalRef.componentInstance.messageAlertClass = 'alert-danger';
    modalRef.componentInstance.hasConfirmation = true;
    modalRef.componentInstance.confirmedCallback = () => {
      this.accountService.logout();
    };

    return false;
  }

  public openClockInOutModal() {
    this.modalService.open(ClockInOutModalComponent);
  }

}
